import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Select from 'react-select';

import { Overlay } from './../UIComponents';
import Carriers from './../../assets/Carriers';
import CarrierInstructions from './../CarrierInstructions';
import './Modal.scss';

export default class CarrierInstructionsModal extends React.Component {
  constructor() {
    super();

    this.state = {
      selectedCarrier: 'ATT',
    };

    this.onDoneClick = this.onDoneClick.bind(this);
    this.onSelectedCarrierChange = this.onSelectedCarrierChange.bind(this);
  }

  onSelectedCarrierChange(item) {
    this.setState({
      selectedCarrier: item.value,
    });
  }

  onDoneClick(event) {
    event.stopPropagation();

    this.props.onClose();
  }

  render() {
    const contentProps = {
      onClick: (e) => { e.stopPropagation(); },
    };

    return (
      <div className={classnames('modal', { open: this.props.visibility })} >
        <Overlay onOverlayClick={this.props.onClose}>
          <div className="carrier-instructions-modal">
            <h4>Carrier Instructions</h4>

            <div className="carrier-instructions-modal__content content" {...contentProps}>
              <div className="content__select">
                <Select
                  value={Carriers.filter((option) => option.value === this.state.selectedCarrier)}
                  getOptionLabel={option => option.label}
                  getOptionValue={option => option.value}
                  options={Carriers}
                  onChange={this.onSelectedCarrierChange}
                />
              </div>

              <div className="content__instructions">
                <CarrierInstructions
                  carrier={this.state.selectedCarrier}
                  twilioNumber={this.props.twilioNumber}
                />
              </div>
            </div>

            <div className="carrier-instructions-modal__actions">
              <button
                className="btn btn--primary btn--lg action"
                onClick={this.onDoneClick}
              >
                Done
              </button>
            </div>
          </div>
        </Overlay>
      </div>
    );
  }
}

CarrierInstructionsModal.defaultProps = {
  twilioNumber: '',
  visibility: false,
  onClose: () => {},
};

CarrierInstructionsModal.propTypes = {
  twilioNumber: PropTypes.string,
  visibility: PropTypes.bool,
  onClose: PropTypes.func,
};
